import React, { useEffect } from "react";
import { createFFmpeg, fetchFile } from "@ffmpeg/ffmpeg";
import { Loader } from "@culturehq/components";

let ffmpeg = createFFmpeg({
  corePath: "https://unpkg.com/@ffmpeg/core@0.10.0/dist/ffmpeg-core.js",
  log: false
});

type GetThumbnailProps = {
  video: any;
  time: number;
  onThumbnail?: (thumb: Blob) => void;
};

const GetThumbnail = ({
  video, onThumbnail, time
}: GetThumbnailProps): React.ReactElement => {
  useEffect(() => {
    const convertSecondsToTimeFormat = () => {
      let seconds = time;
      const hours = Math.floor(seconds / 3600).toString().padStart(2, "0");
      seconds %= 3600;
      const minutes = Math.floor(seconds / 60).toString().padStart(2, "0");
      const secondsString = (seconds % 60).toFixed(3).padStart(6, "0");
      return `${hours}:${minutes}:${secondsString}`;
    };

    const getThumb = async () => {
      const blobFile = await fetch(video).then(file => file.blob());
      // Write the file to memory
      ffmpeg.FS("writeFile", "video.mp4", await fetchFile(blobFile));

      // Run the FFMpeg command
      await ffmpeg.run("-i", "video.mp4", "-ss", convertSecondsToTimeFormat(), "-vframes", "1", "thumbnail.png");

      // Read the result
      const thumb = ffmpeg.FS("readFile", "thumbnail.png");
      const blobThumb = new Blob([new Uint8Array(thumb.buffer)], { type: "image/png" });

      return blobThumb;
    };

    const handleSave = async () => {
      if (onThumbnail) {
        const result = await getThumb();
        onThumbnail(result);
      }
    };

    const load = async () => {
      if (!ffmpeg.isLoaded()) {
        await ffmpeg.load();
      } else {
        try {
          ffmpeg.exit();
        } catch (_) {
          ffmpeg = createFFmpeg({
            corePath: "https://unpkg.com/@ffmpeg/core@0.10.0/dist/ffmpeg-core.js",
            log: false
          });
          await ffmpeg.load();
        }
      }
      await handleSave();
    };

    if (video) {
      load();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <Loader loading />;
};

export default GetThumbnail;
